import {api} from '@/api/factory';

class Links {
    constructor() {}

    getLinks() {
        return api.get('/v1/publisher/videos/links', {
            params: {
                page: 1,
                Limit: 10
            }
        });
    }
}

export default Links